import { request } from "@umijs/max";
import { ApiResponse, LoginRequest, LoginResponse, User } from "@/types";

/** 获取当前的用户 GET /api/auth/current-user */
export async function getCurrentUser(options?: { [key: string]: any }) {
  return request<ApiResponse<User>>("/api/auth/current-user", {
    method: "GET",
    ...(options || {}),
  });
}

/** 登录接口 POST /api/auth/login */
export async function login(
  body: LoginRequest,
  options?: { [key: string]: any },
) {
  return request<ApiResponse<LoginResponse>>("/api/auth/login", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    data: body,
    ...(options || {}),
  });
}

/** 退出登录接口 POST /api/auth/logout */
export async function logout(options?: { [key: string]: any }) {
  return request<ApiResponse<null>>("/api/auth/logout", {
    method: "POST",
    ...(options || {}),
  });
}

/** 修改密码接口 POST /api/auth/change-password */
export async function changePassword(
  body: { oldPassword: string; newPassword: string },
  options?: { [key: string]: any },
) {
  return request<ApiResponse<{ message: string }>>(
    "/api/auth/change-password",
    {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: body,
      ...(options || {}),
    },
  );
}
